<template>
  <div class="product">
    <div
      v-ripple
      class="product-content"
      @click="$emit('add', product)"
    >
      <!-- TITRE PRODUIT -->
      <div class="product-label ellipsis">
        {{ product.label }}
      </div>
      <div class="product-description ellipsis">
        {{ product.description }}
      </div>

      <div
        class="product-quantity"
        :class="{
          'no-product-price': !product.price,
          'no-product-quantity': !product.price && product.quantity === 0
        }"
      >
        <div v-show="product.quantity > 0">
          <span class="green darken-1 white--text pl-1 pt-1 pb-1 mr-1">
            x{{ product.quantity }}
          </span>
          <span class="caption">
            {{ $amount(product.total ? product.total : (product.quantity * product.price)) }}
          </span>
        </div>
      </div>
      <!-- PRIX -->
      <div
        v-if="product.price"
        class="product-price right"
      >
        {{ $amount(product.price) }}
      </div>
    </div>
  </div>
</template>

<script>
import { $amount } from '@/modules/Utils'

export default {
  name: 'MobilProductKey',

  props: {
    product: { type: Object, default: null }
  },

  methods: {
    $amount
  }
}
</script>

<style scoped>
/* Touche produit */
.product {
  display: inline-flex;
  width: 48%;
  margin: 1%;
  cursor: pointer;
  background-color: #424242;
}
.product-content {
  width: 100%;
  min-height: 74px;
  text-align: right;
  padding: 2px 4px;
}
.product-label {
  text-align: left;
  font-size: 16px;
}
.product-description {
  text-align: left;
  font-size: 12px;
}
.product-quantity {
  min-height: 22px;
}
.product-quantity.no-product-price {
  padding-top: 28px;
  padding-bottom: 4px;
}
.product-quantity.no-product-quantity {
  margin-top: 20px;
}
.product-price {
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: normal;
  font-family: 'Roboto', sans-serif;
}
</style>
